import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  categoryWrapper: {
    backgroundColor: "var(--dark)",
    borderRadius: "0 10px 10px 0",
    position: "relative",
    width: "100%",
    maxWidth: "168px",

    "& .categoryProfile": {
      "& .categoryProfileImg": {
        width: "75px",
        height: "75px",
        margin: "30px auto 15px",
      },
      "& .categoryProfileImg img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "50%",
        border: "3px solid var(--primary)",
      },
      "& .categoryProfileContent": {
        textAlign: "center",
        paddingBottom: "30px",
        borderBottom: "1px solid var(--whiteOpacity10)",
      },
      "& .categoryProfileContent .subInnerHeading": {
        marginBottom: "0px",
        color: "var(--white)",
      },
      "& .categoryProfileContent .subHeadingPara": {
        color: "var(--grey)",
        display: "block",
      },
    },
    "& .categoryContent .subHeading": {
      textAlign: "center",
      color: "var(--white)",
      paddingTop: "30px",
    },
    "& .categoryContent .categoryTab": {
      display: "flex",
      flexDirection: "column",
      minHeight: "calc(100vh - 272px)",
      maxHeight: "400px",
      overflow: "auto",
    },
    "& .categoryTab .categoryTabs": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      cursor: "pointer",
      padding: "15px 0",
      margin: "0 15px 15px",
      borderRadius: "10px",
      backgroundColor: "var(--darkSilver)",
    },
    "& .categoryTab .categoryTabs:last-child": {
      margin: "0 15px 0",
    },
    "& .categoryTab .categoryTabs p": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginBottom: "0",
      textAlign: "center",
      marginTop: "5px",
      maxWidth: "150px",
      color: "var(--light)",
    },
    "& .categoryTab .categoryTabs .categoryTabsImg": {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      border: "1px solid var(--blackOpacity10)",
    },
    "& .categoryTab .categoryTabsImg .ant-image": {
      width: "60px",
      borderRadius: "50%",
      height: "60px",
      backgroundColor: "var(--white)",
    },
    "& .categoryTab .categoryTabsImg .ant-image img": {
        width: "100%",
        height: "100%",
      borderRadius: "50%",

        objectFit:"cover",
    },
    "& .categoryTab .categoryTabs.active": {
      backgroundColor: "var(--primary)",
    },
    "& .categoryTab .categoryTabs.active svg path,\n.categoryWrapper .categoryTab .categoryTabs.active p":
      {
        fill: "var(--white)",
        color: "var(--white)",
      },
  },
  activeCategoryWrapper: {
    transform: "translateX(0px)",
  },
});
